/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from "react";
import { PageLoader } from "../../components/PageLoader/PageLoader";
import { useSelector } from "react-redux";
import { IStoreState } from "../../redux/initialStoreState";
import { LoadState } from "../../constants/enums";
import { PageContainer } from "../../components/container/PageContainer";
import {
  Box,
  Button,
  Grid,
  IconButton,
  SelectChangeEvent,
  Stack,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Snackbar,
  Alert,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@mui/material";
import { useDispatchWrapper } from "../../hooks";

import { useFormik } from "formik";
import { StandardCard } from "../../components/Cards";
import {
  ControlledCustomSelect,
  CustomFormLabel,
  CustomTextField,
} from "../../components/formsComponents";
import { Editor } from "../../components/Editor/Editor";
import { Add, Close, LocationOn } from "@mui/icons-material";
import produce from "immer";

import { useBillingCompanyContext } from "../../providers/BillingCompanyProvider";

import { COUNTRY_LIST } from "../../constants/constants";
import { AutoComplete } from "../../components/AutoCompleteSearches/AutoComplete";
import { PreviewTemplate } from "../../components/Preview/PreviewTemplate";
import { FileUpload } from "../../components/FileUpload/components/FileUpload";
import { getUniqueId } from "../../helpers";
import WhatsappBgImg from "../../assets/whatsapp_bg_img.jpg";
import { useNavigate, useParams } from "react-router-dom";
import {
  clearWhatsAppTemplateState,
  fetchWhatsAppTemplateAsync,
  upsertWhatsAppTemplate,
} from "../../redux/whatsappTemplate/whatsappTemplateAction";
import { Breadcrumb } from "../../layout/fullLayout/breadcrumb/Breadcrumb";
import { IBreadcrumbProps } from "../../layout/fullLayout/breadcrumb/IBreadcrumbProps";
import {
  CategoryType,
  HeaderType,
  IWhatsAppTemplateButtons,
  IWhatsAppTemplateData,
  IWhatsAppTemplateHeader,
  MediaType,
  TemplateForType,
} from "../../redux/whatsappTemplate/whatsappTemplate.types";
import { VaraiblesSampleDialog } from "./VaraiblesSampleDialog";
import { convertMarkdownToHtml } from "../../helpers/convertMarkdownToHtml";
import { convertHtmlToMarkdown } from "../../helpers/convertHtmlToMarkdown";
import { PhoneTextField } from "../../components/PhoneTextField/PhoneTextField";
import {
  IAddressDetails,
  ISelectedLocation,
  MapPicker,
} from "../Chatbot/components/MapPicker";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { showMessage } from "../../redux/messages/messagesActions";
import { TEMPLATE_FOR_OPTIONS } from "../../components/WhatsAppTemplateTable/components/TemplateForPopover";
import CustomSwitch from "../../components/customSwitch/customSwitch";
import { MuiNumberField } from "../../components/formsComponents/MuiNumberField";
import { config } from "../../config";

interface IManageWhatsAppTemplateProps {
  onSaveSuccess: (templateData: IWhatsAppTemplateData) => void;
  templateName?: string;
  fromRightPanel?: boolean;
  isFromRecommendedFromRightpanel?: boolean;
  recommendedTemplateDataFromRightpanel?: IWhatsAppTemplateData;
}

export const ManageWhatsAppTemplate: React.FC<IManageWhatsAppTemplateProps> = ({
  templateName,
  onSaveSuccess,
  fromRightPanel = false,
  isFromRecommendedFromRightpanel = false,
  recommendedTemplateDataFromRightpanel = null,
}) => {
  const DEFAULT_COUNTRY_CODE =
    COUNTRY_LIST.find((c) => c.alpha2 === "IN")?.codeWithoutPrefix || "91";

  const CompanyOutletContext = useBillingCompanyContext();
  const navigate = useNavigate();
  const { metaId } = useParams();

  const isUpdate = templateName || metaId ? true : false;

  const BCrumb: IBreadcrumbProps["items"] = [
    {
      to: "/dashboard",
      title: "dashboard",
    },
    {
      to: "/meta-templates",
      title: "Meta Templates",
    },
    {
      title:
        metaId || templateName ? "Edit Meta Template" : "Create Meta Template",
    },
  ];

  const isFromRecommended = isFromRecommendedFromRightpanel || false;
  const recommendedTemplateData = recommendedTemplateDataFromRightpanel;

  const {
    data: whatsAppTemplateData,
    loading: whatsAppTemplateDataLoading,
    error: whatsAppTemplateDataError,
  } = useSelector(
    (storeState: IStoreState) =>
      storeState.whatsappTemplate.whatsAppTemplateData,
  );

  const [openSample, setOpenSample] = React.useState(false);
  const [headerType, setHeaderType] = React.useState<HeaderType>("NONE");
  const [category, setCategory] = React.useState<CategoryType>("");
  const [template_for, setTemplate_for] = React.useState<string[] | null>(null);
  const [mediaType, setMediaType] = React.useState<MediaType>("IMAGE");
  const [buttonType, setButtonType] = React.useState("");
  const [bodyCharCount, setBodyCharCount] = React.useState(0);
  const [uploadedFile, setUploadedFile] = React.useState<File | null>(null);
  const [fileUrl, setFileUrl] = React.useState<string | null>(null);
  const [submitAttempted, setSubmitAttempted] = React.useState(false);
  const [showError, setShowError] = React.useState<string[] | null>(null);
  const [showSampleVariableError, setShowSampleVariableError] =
    React.useState(false);
  const [openMapPicker, setOpenMapPicker] = React.useState<boolean>(false);
  const [selectedLocation, setSelectedLocation] =
    React.useState<ISelectedLocation | null>(null);
  const [autofillBtnText, setAutofillVtnText] = React.useState<boolean>(false);

  const {
    values,
    errors,
    setFieldValue,
    setValues,
    handleChange,
    handleSubmit,
    validateForm,
  } = useFormik({
    initialValues:
      (isFromRecommended ? recommendedTemplateData : whatsAppTemplateData) ||
      whatsAppTemplateData,

    validate: (values) => {
      const errors: any = {};

      // ---------- TEMPLATE NAME ----------
      const nameError = validateName(values.name);
      if (nameError) {
        errors.name = nameError;
      }
      if (!values.name) {
        errors.name = "Template name is required!.";
      }

      // ---------- CATEGORY ----------
      if (!values.category) {
        errors.category = "Category is required!.";
      }

      // ---------- HEADER ----------
      if (headerType === "TEXT") {
        const text = values.header.text || "";
        if (!text.trim()) {
          errors.header = errors.header || {};
          errors.header.text = "Header text is required!";
        } else if (text.length > 60) {
          errors.header = errors.header || {};
          errors.header.text = "Header text must be 60 characters or less";
        }
        // no variables in header text (optional but safer)
        if (/\{\{\d+\}\}/.test(text)) {
          errors.header = errors.header || {};
          errors.header.text =
            "Variables are not allowed in header text for this template";
        }
      }

      // If MEDIA header is selected, make sure at least one file is present
      if (headerType === "MEDIA") {
        const hasHandle =
          values.header?.example?.header_handle &&
          values.header.example.header_handle.length > 0;
        if (!hasHandle && !uploadedFile) {
          errors.header = errors.header || {};
          errors.header.media =
            "Header media is required when header type is Media";
        }
      }

      // ---------- BODY ----------
      const bodyText = convertHtmlToMarkdown(values.body.text || "");
      if (bodyText.length > 1024) {
        errors.body = errors.body || {};
        errors.body.text = "Body text must be 1024 characters or less";
      }
      if (!bodyText.trim() && !isCategoryAuthentication) {
        errors.body = errors.body || {};
        errors.body.text = "Body text is required!";
      }

      // variables cannot be at start or end
      const trimmedBodyText = bodyText.trim();
      if (trimmedBodyText) {
        const startsWithVariable = /^\{\{\d+\}\}/.test(trimmedBodyText);
        const endsWithVariable = /\{\{\d+\}\}$/.test(trimmedBodyText);
        if (startsWithVariable || endsWithVariable) {
          errors.body = errors.body || {};
          errors.body.text =
            "Variables can't be at the start or end of the template content";
        }
      }

      // variables must be sequential {{1}}, {{2}}, ...
      const vars = bodyText.match(/\{\{(\d+)\}\}/g) || [];
      if (vars.length) {
        const indexes = vars.map((v) => parseInt(v.replace(/[{}]/g, ""), 10));
        const unique = Array.from(new Set(indexes)).sort((a, b) => a - b);
        unique.forEach((n, i) => {
          if (n !== i + 1) {
            errors.body = errors.body || {};
            errors.body.text =
              "Variables must be sequential like {{1}}, {{2}}, {{3}} with no gaps";
          }
        });
      }

      // ---------- BODY VARIABLES ----------

      if (showSampleVariableError) {
        errors.body = errors.body || {};
        errors.body.text = "Sample Variables is required!";
      }

      // ---------- FOOTER ----------
      const footerText = values.footer.text || "";
      if (footerText && footerText.length > 60) {
        errors.footer = errors.footer || {};
        errors.footer.text = "Footer text must be 60 characters or less";
      }
      if (/\{\{\d+\}\}/.test(footerText)) {
        errors.footer = errors.footer || {};
        errors.footer.text = "Variables are not allowed in footer";
      }
      if (
        isCategoryAuthentication &&
        !values.footer?.value?.code_expiration_minutes
      ) {
        errors.footer = errors.footer || {};
        errors.footer.value = {
          code_expiration_minutes: "Code expiration minutes is required",
        };
      }

      // ---------- BUTTONS ----------
      if (values.buttons && Array.isArray(values.buttons.buttons)) {
        const btnErrors: any[] = [];

        // Special validation for AUTHENTICATION category
        if (isCategoryAuthentication) {
          const otpButton = values.buttons.buttons[0];

          // Only validate package_name and signature_hash when autofillBtnText is true
          if (autofillBtnText) {
            const buttonError: any = {};

            // Validate package_name
            if (
              !otpButton.value?.package_name ||
              otpButton.value.package_name.trim() === ""
            ) {
              buttonError.package_name =
                "Package name is required for OTP button";
            } else if (otpButton.value.package_name.length > 100) {
              buttonError.package_name =
                "Package name must be 100 characters or less";
            }

            // Validate signature_hash
            if (
              !otpButton.value?.signature_hash ||
              otpButton.value.signature_hash.trim() === ""
            ) {
              buttonError.signature_hash =
                "Signature hash is required for OTP button";
            } else if (otpButton.value.signature_hash.length > 100) {
              buttonError.signature_hash =
                "Signature hash must be 100 characters or less";
            }

            // Only add the error if there are any validation errors
            if (Object.keys(buttonError).length > 0) {
              btnErrors[0] = buttonError;
            }
          } else {
            // When autofill is false, default to Copy Code
          }
        }

        // Only run regular button validation for non-authentication categories
        if (!isCategoryAuthentication) {
          const totalButtons = values.buttons.buttons.length;

          // Global constraint: maximum 3 buttons total
          if (totalButtons > 3) {
            errors.buttons = errors.buttons || {};
            errors.buttons.limitTotal =
              "You can add at most 3 buttons. Please remove an existing button first.";
          }

          const urlButtons = values.buttons.buttons.filter(
            (b) => b.type === "URL",
          );
          const phoneButtons = values.buttons.buttons.filter(
            (b) => b.type === "PHONE_NUMBER",
          );
          const quickReplyButtons = values.buttons.buttons.filter(
            (b) => b.type === "QUICK_REPLY",
          );

          // global constraints
          if (urlButtons.length > 1) {
            errors.buttons = errors.buttons || {};
            errors.buttons.limitUrl =
              "You can add at most one 'Visit Website' button";
          }
          if (phoneButtons.length > 1) {
            errors.buttons = errors.buttons || {};
            errors.buttons.limitPhone =
              "You can add at most one 'Call Phone Number' button";
          }
          if (quickReplyButtons.length > 2) {
            errors.buttons = errors.buttons || {};
            errors.buttons.limitQuickReply =
              "You can add at most 2 Quick Reply buttons";
          }

          // helper validators
          const isPlainButtonText = (t: string) =>
            t.length >= 1 &&
            t.length <= 20 &&
            !/\r|\n/.test(t) &&
            !/\{\{\d+\}\}/.test(t);

          const isValidUrl = (u: string) =>
            /^https?:\/\/[^\s]+$/i.test(u.trim());

          const isValidPhone = (p: string) =>
            /^\+?[1-9]\d{6,14}$/.test(p.replace(/\s/g, ""));

          values.buttons.buttons.forEach((btn, index) => {
            const thisError: any = {};

            if (btn.type === "URL") {
              // Button text
              if (!btn.text || !btn.text.trim()) {
                thisError.text = "Button text is required for Visit Website";
              } else if (!isPlainButtonText(btn.text.trim())) {
                thisError.text =
                  "Button text must be 1–20 plain characters with no variables or line breaks";
              }

              // URL
              if (!btn.url || !btn.url.trim()) {
                thisError.url = "Website URL is required";
              } else if (!isValidUrl(btn.url)) {
                thisError.url = "Website URL must start with http or https";
              }
              if (btn.url?.includes("{{1}}") && !(btn as any).sampleVariable?.trim()) {
                thisError.sampleVariable = "Sample variable is required";
              }
            }

            if (btn.type === "PHONE_NUMBER") {
              if (!btn.country_code) {
                thisError.country_code = "Country is required";
              }
              if (!btn.text || !btn.text.trim()) {
                thisError.text = "Button text is required for Call button";
              } else if (!isPlainButtonText(btn.text.trim())) {
                thisError.text =
                  "Button text must be 1–20 plain characters with no variables or line breaks";
              }
              if (!btn.phone_number || !btn.phone_number.trim()) {
                thisError.phone_number = "Phone number is required";
              } else if (
                !isValidPhone(
                  `${btn.country_code || ""}${btn.phone_number || ""}`,
                )
              ) {
                thisError.phone_number =
                  "Phone number must be a valid international number";
              }
            }

            if (btn.type === "QUICK_REPLY") {
              if (!btn.text || !btn.text.trim()) {
                thisError.text = "Button text is required for Quick Reply";
              } else if (!isPlainButtonText(btn.text.trim())) {
                thisError.text =
                  "Quick Reply text must be 1–20 plain characters with no variables or line breaks";
              }
            }

            btnErrors[index] = thisError;
          });
        }

        // attach any per‑button errors - THIS IS THE CRITICAL PART
        if (btnErrors.some((e) => e && Object.keys(e).length > 0)) {
          if (!errors.buttons) {
            errors.buttons = {};
          }
          errors.buttons.buttons = btnErrors;
        }
      }

      return errors;
    },
    onSubmit: (values) => {
      setSubmitAttempted(true);
      const finalButtons: IWhatsAppTemplateButtons["buttons"] = [];

      for (const item of values.buttons.buttons) {
        if (item.type === "PHONE_NUMBER") {
          finalButtons.push({
            text: item.text,
            type: item.type,
            phone_number: item.country_code + "" + item.phone_number,
          });
        } else {
          const { urlType, ...rest } = item as any;
          finalButtons.push(rest);
        }
      }

      const updatedValues: IWhatsAppTemplateData = {
        ...values,
        company_outlet_uuid: CompanyOutletContext.comapny.company_outlet_uuid,
        template_for: (template_for ||
          values.template_for ||
          []) as TemplateForType[],
        header: {
          ...values.header,
          format:
            headerType === "TEXT"
              ? "TEXT"
              : headerType === "MEDIA"
                ? mediaType
                : headerType === "LOCATION"
                  ? "LOCATION"
                  : null,
        },
        body: {
          ...values.body,
          text: convertHtmlToMarkdown(values.body.text),
          example: {
            body_text: Array.isArray(values.example.body_text)
              ? [values.example.body_text.flat()]
              : [[values.example.body_text].flat()],
          },
        },
        example: {
          ...values.example,
          body_text: Array.isArray(values.example.body_text)
            ? values.example.body_text.flat()
            : [values.example.body_text].flat(),
        },
        buttons: {
          ...values.buttons,
          buttons: finalButtons,
        },
        meta_id: metaId ? metaId : null,
      };

      dispatch(
        upsertWhatsAppTemplate(
          updatedValues as IWhatsAppTemplateData,
          isCategoryAuthentication ? true : false,
          autofillBtnText ? true : false,
          (isSuccess, templateData) => {
            if (isSuccess) {
              fromRightPanel
                ? onSaveSuccess(templateData as IWhatsAppTemplateData)
                : navigate("/meta-templates");
            }
          },
        ),
      );
    },
  });

  // Check for missing sample variables whenever body text or example values change
  const checkSampleVariableError = React.useCallback(() => {
    const regex = /\{\{.*?\}\}/g; // Matches {{number}} pattern
    const foundMatches = values?.body?.text?.match(regex) || [];

    if (foundMatches.length === 0) {
      setShowSampleVariableError(false);
      return;
    }

    // Check if sample values exist for all variables
    const sampleValues = values.example?.body_text || [];

    const hasEmptyOrMissingSamples = foundMatches.some((_, index) => {
      const sampleValue = sampleValues[index];
      return !sampleValue || sampleValue.trim() === "";
    });

    setShowSampleVariableError(hasEmptyOrMissingSamples);
  }, [values.body.text, values.example?.body_text]);

  // Run the check whenever body text or sample values change
  React.useEffect(() => {
    checkSampleVariableError();
  }, [checkSampleVariableError]);

  const flattenErrors = (errors: any): string[] => {
    const errorMessages: string[] = [];

    const extractErrors = (obj: any, prefix = "") => {
      if (obj === null || obj === undefined) return;

      if (typeof obj === "string") {
        errorMessages.push(obj);
        return;
      }

      if (typeof obj === "object") {
        Object.keys(obj).forEach((key) => {
          const value = obj[key];
          if (typeof value === "string") {
            errorMessages.push(value);
          } else if (typeof value === "object" && value !== null) {
            extractErrors(value, key);
          }
        });
      }
    };

    extractErrors(errors);
    return errorMessages;
  };

  const handleGlobalSaveClick = async () => {
    const formErrors = await validateForm();
    setSubmitAttempted(true);
    const flattenedErrors = flattenErrors(formErrors);
    if (flattenedErrors.length > 0) {
      setShowError(flattenedErrors as any);
      return;
    }

    setShowError(null);
    handleSubmit();
  };
  const editorRef = useRef<{
    insertTextAtCursor: (text: string) => void;
  } | null>(null);

  const dispatch = useDispatchWrapper();

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
      .toLowerCase() // Convert to lowercase
      .replace(/\s+/g, "_") // Replace spaces with underscores
      .replace(/[^a-z0-9_]/g, ""); // Remove any other special characters

    setFieldValue("name", value);
  };

  const handleButtonType = (e: SelectChangeEvent<unknown>) => {
    const value = e.target.value as string;

    setButtonType(value);
    const newValues = produce(values, (draftValues) => {
      if (!draftValues.buttons.buttons.some((x) => x.type === value)) {
        draftValues.buttons.buttons.push({
          type: value,
          text: "",
          ...(value === "PHONE_NUMBER" && {
            country_code: DEFAULT_COUNTRY_CODE,
            phone_number: "",
          }),
        });
      }
    });
    setValues(newValues);
  };

  const handleAddClick = (type: string) => () => {
    const newvalues = produce(values, (draftValues) => {
      draftValues.buttons.buttons.push({
        type: type,
        text: "",
        ...(type === "PHONE_NUMBER" && {
          country_code: DEFAULT_COUNTRY_CODE,
          phone_number: "",
        }),
      });
    });
    setValues(newvalues);
  };

  const handleButtonsTextChange =
    (type: string, index: number, key: string) =>
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const newvalues = produce(values, (draftValues) => {
          const filteredDraftValues = draftValues.buttons.buttons.filter(
            (x) => x.type === type,
          );
          filteredDraftValues[index][key as "text"] = e.target.value;
        });
        setValues(newvalues);
      };

  const handleButtonsAutocompleteChange =
    (type: string, index: number, key: string) => (value: string) => {
      const newvalues = produce(values, (draftValues) => {
        const filteredDraftValues = draftValues.buttons.buttons.filter(
          (x) => x.type === type,
        );
        filteredDraftValues[index][key as "text"] = value as string;
      });
      setValues(newvalues);
    };

  const handleDeleteClick = (index: number) => () => {
    const newvalues = produce(values, (draftValues) => {
      draftValues.buttons.buttons.splice(index, 1);
    });
    setValues(newvalues);
    setButtonType("");
  };

  const handleAddVaraible = () => {
    if (editorRef.current) {
      const regex = /\{\{.*?\}\}/g; // Matches {{number}} pattern
      const foundMatches = values.body.text.match(regex) || [];
      editorRef.current.insertTextAtCursor(`{{${foundMatches.length + 1}}}`);
    }
  };

  const handleSaveVaraible = (list: string[], files: any[]) => {
    const prevFiles = values?.header?.example?.header_handle || [];
    const newFiles = files.filter(
      (file) =>
        !prevFiles.some(
          (prev) =>
            (file.path && prev.path && file.path === prev.path) ||
            (file.file && prev.file && file.file === prev.file),
        ),
    );

    const newValues = produce(values, (draftValues) => {
      draftValues.example.body_text = list;
      if (!draftValues.header.example) {
        draftValues.header.example = {
          header_text: [],
          header_handle: null,
        };
      }
      draftValues.header.example.header_handle = [...prevFiles, ...newFiles];
    });
    setValues(newValues);

    // Sync with uploaded file state if files were uploaded in sample dialog
    if (files.length > 0 && files[0].file) {
      setUploadedFile(files[0].file);
    }

    setOpenSample(false);
  };

  const handleHeaderTypeChange = (e: SelectChangeEvent<unknown>) => {
    const value = e.target.value as HeaderType;
    setHeaderType(value);
    setValues({
      ...values,
      header: {
        ...values.header,
        text: null,
      },
    });
  };

  const handleCategoryTypeChange = (e: SelectChangeEvent<unknown>) => {
    const value = e.target.value as CategoryType;
    setCategory(value);

    if (value === "AUTHENTICATION") {
      setValues({
        ...values,
        category: value,
        body: {
          type: "BODY",
          text: "",
          example: {
            body_text: [],
          },
          value: {
            add_security_recommendation: true,
          },
        },
        footer: {
          type: "FOOTER",
          text: "",
          value: {
            code_expiration_minutes: null,
          },
        },
        buttons: {
          type: "BUTTONS",
          buttons: [
            {
              type: "OTP",
              text: "Copy Code",
              value: {
                otp_type: "COPY_CODE",
                text: "Copy Code",

                autofill_text: "",
                package_name:
                  values?.buttons?.buttons[0]?.value?.package_name || "",
                signature_hash:
                  values?.buttons?.buttons[0]?.value?.signature_hash || "",
              },
            },
          ],
        },
        header: {
          ...values.header,
          format: null,
          text: null,
          example: {
            header_text: [],
            header_handle: null,
          },
        },
        example: {
          ...values.example,
          body_text: [],
        },
      });

      setHeaderType("NONE");
      setUploadedFile(null);
      setFileUrl(null);
      setBodyCharCount(0);
      setButtonType("");
      setShowSampleVariableError(false);
      setAutofillVtnText(false);
    } else {
      setValues({
        ...values,
        buttons: {
          type: "BUTTONS",
          buttons: [],
        },
        category: value,
      });
      setAutofillVtnText(false);
    }
  };

  const handleTemplateForChange = (e: SelectChangeEvent<unknown>) => {
    const value = e.target.value;
    // Handle both single value and array of values
    const selectedValues = Array.isArray(value) ? value : value ? [value] : [];
    setTemplate_for(selectedValues as string[]);
    setValues({
      ...values,
      template_for: selectedValues as TemplateForType[],
    });
  };

  const handleHeaderTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      header: {
        ...values.header,
        text: e.target.value,
      },
    });
  };

  const handleMediaTypeChange = (type: MediaType) => {
    setMediaType(type);
    setValues({
      ...values,
      header: {
        ...values.header,
        format: type,
        example: {
          header_text: [],
          header_handle: [],
        },
      },
    });
  };

  const handleFileUpload = (file: File) => {
    setUploadedFile(file);
    const newValues = produce(values, (draftValues) => {
      if (!draftValues.header.example.header_handle) {
        draftValues.header.example.header_handle = [];
      }
      // Replace the first file or add new one
      if (draftValues.header.example.header_handle.length > 0) {
        draftValues.header.example.header_handle[0] = {
          key: getUniqueId(),
          path: null,
          file: file,
          name: file.name,
        };
      } else {
        draftValues.header.example.header_handle.push({
          key: getUniqueId(),
          path: null,
          file: file,
          name: file.name,
        });
      }
    });
    setValues(newValues);
  };

  const handleFileDelete = () => {
    setUploadedFile(null);
    setFileUrl(null);
    const newValues = produce(values, (draftValues) => {
      if (draftValues.header.example.header_handle) {
        draftValues.header.example.header_handle = [];
      }
    });
    setValues(newValues);
  };

  const handleBodyChange = (html: string) => {
    const markdown = convertHtmlToMarkdown(html);
    setBodyCharCount(markdown.length);
    setValues({
      ...values,
      body: {
        ...values.body,
        text: html,
      },
    });
  };

  const handleLocationSelect = async (
    place: any,
    addressDetails?: IAddressDetails,
    selectedLocation?: ISelectedLocation,
  ) => {
    if (!place || !place.value) return;

    const placeId = place.value.place_id;
    if (!placeId) return;

    const response = await geocodeByPlaceId(placeId);
    const { geometry } = response[0];
    const { lat, lng } = geometry.location;

    if (selectedLocation) {
      dispatch(
        showMessage({
          type: "success",
          message: `Selected Location Successfully`,
          displayAs: "snackbar",
        }),
      );

      setOpenMapPicker(false);
      setSelectedLocation(selectedLocation);
    } else {
      dispatch(
        showMessage({
          type: "error",
          message: `Failed to select lat & lng`,
          displayAs: "snackbar",
        }),
      );

      setOpenMapPicker(false);
    }
  };

  React.useEffect(() => {
    if (values.category) {
      setCategory(values.category as CategoryType);
    }
  }, [values.category]);

  React.useEffect(() => {
    if (metaId || templateName) {
      dispatch(
        fetchWhatsAppTemplateAsync({
          templateName: templateName || "",
          companyOutletUuid: CompanyOutletContext.comapny.company_outlet_uuid,
          metaID: metaId,
        }),
      );
    }

    return () => {
      dispatch(clearWhatsAppTemplateState());
    };
  }, [templateName, metaId]);

  React.useEffect(() => {
    // Update form when template data is fetched (for edit mode)
    if (
      isUpdate &&
      whatsAppTemplateData &&
      Object.keys(whatsAppTemplateData).length > 0 &&
      whatsAppTemplateData.whatsapp_template_uuid
    ) {
      // Find the header component from the components array
      const headerComponent = whatsAppTemplateData.components?.find(
        (component) => component.type === "HEADER",
      ) as IWhatsAppTemplateHeader | undefined; // Type assertion to help TypeScript

      let headerTypeValue: HeaderType = "NONE";

      if (headerComponent) {
        // Now TypeScript knows this is a header component with format property
        if (headerComponent.format === "TEXT") {
          headerTypeValue = "TEXT";
        } else if (
          headerComponent.format === "IMAGE" ||
          headerComponent.format === "VIDEO" ||
          headerComponent.format === "DOCUMENT"
        ) {
          headerTypeValue = "MEDIA";
        } else if (headerComponent.format === "LOCATION") {
          headerTypeValue = "LOCATION";
        }
      }

      setHeaderType(headerTypeValue);

      // Set media type if header is MEDIA type
      if (headerTypeValue === "MEDIA" && headerComponent?.format) {
        setMediaType(headerComponent.format as MediaType);
      }

      if (whatsAppTemplateData.attachment) {
        const fileUrl = whatsAppTemplateData.attachment[0] as unknown as string;
        setFileUrl(
          `${config.assets.s3BaseUrl}/${fileUrl}`,
        );
      }

      // Initialize template_for state if present in whatsAppTemplateData
      if (
        whatsAppTemplateData.template_for &&
        whatsAppTemplateData.template_for.length > 0
      ) {
        setTemplate_for(whatsAppTemplateData.template_for as string[]);
      } else if (whatsAppTemplateData.template_for === null) {
        setTemplate_for([]);
      }

      // Set category if present
      if (whatsAppTemplateData.category) {
        setCategory(whatsAppTemplateData.category as CategoryType);
      }

      // Convert markdown to HTML when loading saved data for the editor
      const updatedData = { ...whatsAppTemplateData };
      if (
        whatsAppTemplateData.body?.text &&
        !whatsAppTemplateData.body.text.includes("<") // Check if it's markdown (no HTML tags)
      ) {
        // Convert markdown to HTML for the editor
        updatedData.body = {
          ...updatedData.body,
          text: convertMarkdownToHtml(whatsAppTemplateData.body.text),
        };
      }

      // Update formik values with fetched data
      if (updatedData?.buttons?.buttons && Array.isArray(updatedData.buttons.buttons)) {
        updatedData.buttons = {
          ...updatedData.buttons,
          buttons: updatedData.buttons.buttons.map((btn: any) => {
            if (btn?.type !== "PHONE_NUMBER") return btn;
            return {
              ...btn,
              country_code: btn.country_code || DEFAULT_COUNTRY_CODE,
              phone_number: btn.phone_number || "",
            };
          }),
        };
      }
      setValues(updatedData);

      // Sync uploaded file state if there's an existing file
      if (whatsAppTemplateData.header?.example?.header_handle?.[0]?.file) {
        setUploadedFile(
          whatsAppTemplateData.header.example.header_handle[0].file,
        );
      }

      // Calculate body character count
      if (whatsAppTemplateData.body?.text) {
        const markdown = convertHtmlToMarkdown(
          updatedData.body?.text || whatsAppTemplateData.body.text,
        );
        setBodyCharCount(markdown.length);
      }
    }
  }, [whatsAppTemplateData, isUpdate]);

  React.useEffect(() => {
    const handleAddVariable = () => {
      handleAddVaraible();
    };

    document.addEventListener("addVariable", handleAddVariable);

    return () => {
      document.removeEventListener("addVariable", handleAddVariable);
    };
  }, [values.body.text]);

  const validateName = (name: string) => {
    if (!name) {
      return "Template Name is required!";
    }

    // Check for uppercase letters
    if (/[A-Z]/.test(name)) {
      return "Name must be in lowercase letters only";
    }

    // Check for spaces
    if (/\s/.test(name)) {
      return "Spaces are not allowed. Use underscores (_) instead";
    }

    // Check for special characters (only allow lowercase letters, numbers, and underscores)
    if (!/^[a-z0-9_]+$/.test(name)) {
      return "Only lowercase letters, numbers, and underscores are allowed";
    }

    // if Max length 512 characters
    if (name.length > 512) {
      return "Name must be 512 characters or less";
    }
    return null;
  };

  const isCategoryAuthentication = values.category === "AUTHENTICATION";

  const getFooterError = () => {
    if (!submitAttempted || !errors.footer?.value) return undefined;

    // Check if value is an object and has code_expiration_minutes property
    if (
      typeof errors.footer.value === "object" &&
      errors.footer.value !== null
    ) {
      return (errors.footer.value as any).code_expiration_minutes;
    }

    return undefined;
  };

  return (
    <>
      <PageLoader
        loading={whatsAppTemplateDataLoading === LoadState.InProgress}
        error={
          whatsAppTemplateDataError
            ? { message: whatsAppTemplateDataError || "Error loading template" }
            : null
        }
      >
        <PageContainer
          title={templateName ? "Edit Template" : "Create New Template"}
          description="this is inner page"
        >
          {!fromRightPanel && (
            <Breadcrumb title="Create Meta Template" items={BCrumb} />
          )}
          <StandardCard
            renderWithoutCard={fromRightPanel}
            heading={
              metaId || templateName
                ? "Edit Meta Template"
                : !fromRightPanel
                  ? "Create Meta Template"
                  : ""
            }
          >
            <form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12} md={4}>
                  <CustomFormLabel>Name</CustomFormLabel>
                  <CustomTextField
                    fullWidth
                    name="name"
                    value={values.name}
                    onChange={handleNameChange}
                    error={submitAttempted && errors.name ? true : false}
                    helperText={submitAttempted ? errors.name : ""}
                    placeholder="(eg: my_template_name, lowercase letters, and underscores only)"
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <CustomFormLabel>Template For</CustomFormLabel>

                  <ControlledCustomSelect
                    fullWidth
                    value={template_for || []}
                    multiple
                    options={[...TEMPLATE_FOR_OPTIONS]}
                    onChange={handleTemplateForChange}
                    displayEmpty
                    placeholder="Select Template For"
                    error={
                      submitAttempted && errors.template_for ? true : false
                    }
                    helperText={submitAttempted ? errors.template_for : ""}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <CustomFormLabel>Category</CustomFormLabel>

                  <ControlledCustomSelect
                    fullWidth
                    value={category}
                    options={[
                      { label: "Authentication", value: "AUTHENTICATION" },
                      { label: "Marketing", value: "MARKETING" },
                      { label: "Utility", value: "UTILITY" },
                    ]}
                    onChange={handleCategoryTypeChange}
                    displayEmpty
                    placeholder="Select category"
                    error={submitAttempted && errors.category ? true : false}
                    helperText={submitAttempted ? errors.category : ""}
                  />
                </Grid>

                {!isCategoryAuthentication && (
                  <Grid item xs={12} md={6}>
                    <CustomFormLabel>Header</CustomFormLabel>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <ControlledCustomSelect
                          fullWidth
                          value={headerType}
                          options={[
                            { label: "None", value: "NONE" },
                            { label: "Text", value: "TEXT" },
                            { label: "Media", value: "MEDIA" },
                            { label: "Location", value: "LOCATION" },
                          ]}
                          onChange={handleHeaderTypeChange}
                          displayEmpty
                          placeholder="Select header type"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        {headerType === "TEXT" ? (
                          <CustomTextField
                            name="header.text"
                            value={values.header.text}
                            onChange={handleHeaderTextChange}
                            fullWidth
                            placeholder="Enter header text"
                            error={
                              submitAttempted &&
                              !!(errors.header && errors.header.text)
                            }
                            helperText={
                              submitAttempted
                                ? errors.header && errors.header.text
                                : ""
                            }
                          />
                        ) : headerType === "MEDIA" ? (
                          <Grid container spacing={2}>
                            <Grid
                              item
                              display={"flex"}
                              flexDirection={"column"}
                              xs={12}
                            >
                              <Box display={"flex"} alignItems={"center"}>
                                <FormControl>
                                  <RadioGroup
                                    row
                                    value={mediaType}
                                    onChange={(e) =>
                                      handleMediaTypeChange(
                                        e.target.value as MediaType,
                                      )
                                    }
                                  >
                                    <FormControlLabel
                                      value="IMAGE"
                                      control={<Radio />}
                                      label="Image"
                                    />
                                    <FormControlLabel
                                      value="VIDEO"
                                      control={<Radio />}
                                      label="Video"
                                    />
                                    <FormControlLabel
                                      value="DOCUMENT"
                                      control={<Radio />}
                                      label="Document"
                                    />
                                  </RadioGroup>
                                </FormControl>
                                <FileUpload
                                  value={
                                    uploadedFile?.name ||
                                    values.header?.example?.header_handle?.[0]
                                      ?.name ||
                                    fileUrl ||
                                    ""
                                  }
                                  accept={
                                    mediaType === "IMAGE"
                                      ? "image/*"
                                      : mediaType === "VIDEO"
                                        ? "video/*"
                                        : ".pdf,.doc,.docx,.txt,.xls,.xlsx,.ppt,.pptx"
                                  }
                                  onChange={handleFileUpload}
                                  onDelete={handleFileDelete}
                                  heading=""
                                />
                              </Box>
                              {submitAttempted &&
                                errors.header &&
                                (errors.header as any).media && (
                                  <Typography
                                    variant="caption"
                                    color="error"
                                    sx={{ mt: 0.5 }}
                                  >
                                    {(errors.header as any).media}
                                  </Typography>
                                )}
                            </Grid>
                          </Grid>
                        ) : headerType === "LOCATION" ? (
                          <>
                            {selectedLocation ? (
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 2,
                                  bgcolor: "background.paper",
                                  borderRadius: 2,
                                }}
                              >
                                <Stack spacing={2}>
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent={"space-between"}
                                  >
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      gap={1}
                                    >
                                      <LocationOn color="primary" />
                                      <Typography variant="h6" fontWeight={600}>
                                        {selectedLocation.name}
                                      </Typography>
                                    </Box>
                                    <IconButton
                                      onClick={() => setSelectedLocation(null)}
                                    >
                                      <Close />
                                    </IconButton>
                                  </Box>

                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    {selectedLocation.address}
                                  </Typography>

                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: 3,
                                      flexWrap: "wrap",
                                      pt: 1,
                                      borderTop: "1px solid",
                                      borderColor: "divider",
                                    }}
                                  >
                                    <Box>
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                      >
                                        Latitude
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        fontWeight={500}
                                      >
                                        {selectedLocation.latitude.toFixed(6)}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                      >
                                        Longitude
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        fontWeight={500}
                                      >
                                        {selectedLocation.longitude.toFixed(6)}
                                      </Typography>
                                    </Box>
                                  </Box>

                                  <Button
                                    variant="contained"
                                    color={"success"}
                                    onClick={() => setOpenMapPicker(true)}
                                  >
                                    Update Selected Location
                                  </Button>
                                </Stack>
                              </Paper>
                            ) : (
                              <Button
                                variant="contained"
                                onClick={() => setOpenMapPicker(true)}
                              >
                                Select Location
                              </Button>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                <Grid item xs={12} md={8}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} mt={2}>
                      <Typography variant="h3" fontWeight={600}>
                        Body
                      </Typography>
                      {!isCategoryAuthentication && (
                        <>
                          <Editor
                            content={values.body.text}
                            ref={editorRef}
                            height={300}
                            onChange={handleBodyChange}
                          />

                          <Stack>
                            <Stack direction={"row"} justifyContent={"start"}>
                              <Typography
                                variant="caption"
                                color={
                                  bodyCharCount > 1024
                                    ? "error"
                                    : "textSecondary"
                                }
                                sx={{ mr: 2 }}
                              >
                                {bodyCharCount}/1024 characters
                                {bodyCharCount > 1024 && " - Exceeds limit!"}
                              </Typography>
                              {submitAttempted &&
                                errors.body &&
                                errors.body.text && (
                                  <Typography
                                    variant="caption"
                                    color="error"
                                    display="block"
                                  >
                                    {typeof errors.body.text === "string"
                                      ? errors.body.text
                                      : "Body text is required!"}
                                  </Typography>
                                )}
                            </Stack>
                          </Stack>
                        </>
                      )}
                      {isCategoryAuthentication && (
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography>
                            Do you want to add security recommendation?
                          </Typography>
                          <CustomSwitch
                            name="body.value.add_security_recommendation"
                            checked={
                              values?.body?.value
                                ?.add_security_recommendation || false
                            }
                            onChange={() => {
                              setFieldValue(
                                "body.value.add_security_recommendation",
                                !(
                                  values?.body?.value
                                    ?.add_security_recommendation || false
                                ),
                              );
                            }}
                          />
                        </Box>
                      )}
                    </Grid>
                    <Grid item xs={12} mt={2}>
                      <Typography variant="h3" fontWeight={600}>
                        Footer
                      </Typography>
                      {!isCategoryAuthentication && (
                        <CustomTextField
                          name="footer.text"
                          value={values.footer.text}
                          error={
                            submitAttempted &&
                            !!(errors.footer && errors.footer.text)
                          }
                          helperText={
                            submitAttempted
                              ? errors.footer && errors.footer.text
                              : ""
                          }
                          onChange={handleChange}
                          fullWidth
                        />
                      )}

                      {isCategoryAuthentication && (
                        <Grid item xs={12} md={6}>
                          <MuiNumberField
                            sx={{ mt: 2 }}
                            label="Code Expiration Minutes"
                            name="footer.value.code_expiration_minutes"
                            value={
                              values?.footer?.value?.code_expiration_minutes ||
                              ""
                            }
                            onChange={(e) => {
                              const newValue =
                                e.target.value === ""
                                  ? null
                                  : Number(e.target.value);
                              setFieldValue(
                                "footer.value.code_expiration_minutes",
                                newValue,
                              );
                            }}
                            max={999} // Optional: set a max value if needed
                            placeholder="Enter expiration time in minutes"
                            info="How many minutes until the code expires"
                            error={getFooterError()}
                          />
                        </Grid>
                      )}
                    </Grid>
                    <Grid item xs={12} mt={2} mb={10}>
                      {!isCategoryAuthentication && (
                        <Typography variant="h3" fontWeight={600}>
                          Buttons
                        </Typography>
                      )}
                      {/* {isCategoryAuthentication ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            mt: 2,
                          }}
                        >
                          <Typography>Do you want to autofill text?</Typography>
                          <CustomSwitch
                            name="autofillBtnText"
                            checked={autofillBtnText}
                            onChange={() => {
                              setAutofillVtnText(!autofillBtnText);
                            }}
                          />
                        </Box>
                      ) : (
                        <Typography variant="body1" fontSize={"0.9rem"}>
                          Create buttons that let customers respond to your
                          message to action.
                        </Typography>
                      )} */}

                      {!isCategoryAuthentication && (
                        <Grid container spacing={1} mt={1}>
                          <Grid item xs={12} md={6}>
                            <ControlledCustomSelect
                              value={buttonType}
                              fullWidth
                              options={[
                                {
                                  label: "Quick reply buttons",
                                  value: "QUICK_REPLY",
                                },
                                {
                                  label: "Visit website",
                                  value: "URL",
                                },
                                {
                                  label: "Call Phone Number",
                                  value: "PHONE_NUMBER",
                                },
                              ]}
                              onChange={handleButtonType}
                              displayEmpty
                              placeholder="+ Add New Button"
                            />
                          </Grid>

                          {/* Display global button limit errors */}
                          {submitAttempted && errors.buttons && (
                            <Grid item xs={12}>
                              {(errors.buttons as any).limitUrl && (
                                <Typography
                                  variant="caption"
                                  color="error"
                                  display="block"
                                >
                                  {(errors.buttons as any).limitUrl}
                                </Typography>
                              )}
                              {(errors.buttons as any).limitPhone && (
                                <Typography
                                  variant="caption"
                                  color="error"
                                  display="block"
                                >
                                  {(errors.buttons as any).limitPhone}
                                </Typography>
                              )}
                              {(errors.buttons as any).limitQuickReply && (
                                <Typography
                                  variant="caption"
                                  color="error"
                                  display="block"
                                >
                                  {(errors.buttons as any).limitQuickReply}
                                </Typography>
                              )}
                            </Grid>
                          )}

                          {values.buttons.buttons.some(
                            (x) => x.type === "URL",
                          ) && (
                              <>
                                <Grid item xs={12} mt={2}>
                                  <Stack
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                    spacing={1}
                                    mt={1}
                                  >
                                    <Typography variant="h3" fontWeight={600}>
                                      Visit Website
                                    </Typography>
                                  </Stack>
                                  {values.buttons.buttons
                                    .filter((x) => x.type === "URL")
                                    .map((button, index) => {
                                      // Get actual index in the full buttons array for error access
                                      const actualIndex =
                                        values.buttons.buttons.findIndex(
                                          (b, i) =>
                                            b.type === "URL" &&
                                            values.buttons.buttons
                                              .slice(0, i + 1)
                                              .filter((x) => x.type === "URL")
                                              .length ===
                                            index + 1,
                                        );
                                      const buttonErrors = (errors.buttons as any)
                                        ?.buttons?.[actualIndex];
                                      return (
                                        <Grid
                                          key={index}
                                          container
                                          mt={1}
                                          spacing={1}
                                        >
                                          <Grid item xs={3}>
                                            <CustomFormLabel
                                              sx={{ fontWeight: 600 }}
                                            >
                                              Button Text
                                            </CustomFormLabel>
                                            <CustomTextField
                                              fullWidth
                                              value={button.text}
                                              onChange={handleButtonsTextChange(
                                                "URL",
                                                index,
                                                "text",
                                              )}
                                              error={
                                                submitAttempted &&
                                                !!buttonErrors?.text
                                              }
                                              helperText={
                                                submitAttempted
                                                  ? buttonErrors?.text || ""
                                                  : ""
                                              }
                                            />
                                          </Grid>

                                          <Grid item xs={2.5}>
                                            <CustomFormLabel sx={{ fontWeight: 600 }}>URL Type</CustomFormLabel>
                                            <ControlledCustomSelect
                                              fullWidth
                                              value={(button as any).urlType || (button.url?.includes("{{1}}") ? "DYNAMIC" : "STATIC")}
                                              options={[
                                                { label: "Static", value: "STATIC" },
                                                { label: "Dynamic", value: "DYNAMIC" },
                                              ]}
                                              onChange={(e) => {
                                                const type = e.target.value;
                                                const newValues = produce(values, (draft) => {
                                                  const actualBtn = draft.buttons.buttons[actualIndex] as any;
                                                  actualBtn.urlType = type;
                                                  if (type === "STATIC" && actualBtn.url) {
                                                    actualBtn.url = actualBtn.url.replace("{{1}}", "");
                                                  }
                                                });
                                                setValues(newValues);
                                              }}
                                            />
                                          </Grid>

                                          <Grid item xs={5.5}>
                                            <CustomFormLabel
                                              sx={{ fontWeight: 600 }}
                                            >
                                              Website Url
                                            </CustomFormLabel>
                                            <Stack direction="row" spacing={1} alignItems="flex-start">
                                              <CustomTextField
                                                fullWidth
                                                value={button.url}
                                                onChange={handleButtonsTextChange(
                                                  "URL",
                                                  index,
                                                  "url",
                                                )}
                                                error={
                                                  submitAttempted &&
                                                  !!buttonErrors?.url
                                                }
                                                helperText={
                                                  submitAttempted
                                                    ? buttonErrors?.url || ""
                                                    : ""
                                                }
                                              />
                                              {((button as any).urlType === "DYNAMIC" || button.url?.includes("{{1}}")) && (
                                                <Button
                                                  variant="contained"
                                                  disabled={button.url?.includes("{{1}}")}
                                                  sx={{ minWidth: "auto", px: 2, height: "42px" }}
                                                  onClick={() => {
                                                    const newValues = produce(values, (draft) => {
                                                      const actualBtn = draft.buttons.buttons[actualIndex];
                                                      const currentUrl = actualBtn.url || "";
                                                      actualBtn.url = currentUrl + "{{1}}";
                                                    });
                                                    setValues(newValues);
                                                  }}
                                                >
                                                  {"{{1}}"}
                                                </Button>
                                              )}
                                            </Stack>
                                          </Grid>

                                          <Grid item xs={1}>
                                            <Stack
                                              direction={"row"}
                                              height={"100%"}
                                              alignItems={"center"}
                                              justifyContent={"center"}
                                              spacing={1}
                                            >
                                              <Button
                                                variant="text"
                                                startIcon={<Close />}
                                                sx={{ mb: 2 }}
                                                onClick={handleDeleteClick(
                                                  actualIndex,
                                                )}
                                              ></Button>
                                            </Stack>
                                          </Grid>

                                          {((button as any).urlType === "DYNAMIC" || button.url?.includes("{{1}}")) && (
                                            <Grid item xs={12} mt={1}>
                                              <CustomFormLabel sx={{ fontWeight: 600 }}>Add Sample variable</CustomFormLabel>
                                              <CustomTextField
                                                fullWidth
                                                placeholder="Enter sample value for {{1}}"
                                                value={(button as any).sampleVariable || ""}
                                                onChange={(e) => {
                                                  const val = e.target.value;
                                                  const newValues = produce(values, (draft) => {
                                                    const actualBtn = draft.buttons.buttons[actualIndex] as any;
                                                    actualBtn.sampleVariable = val;
                                                  });
                                                  setValues(newValues);
                                                }}
                                                error={submitAttempted && !!(buttonErrors as any)?.sampleVariable}
                                                helperText={submitAttempted ? (buttonErrors as any)?.sampleVariable || "" : ""}
                                              />
                                            </Grid>
                                          )}
                                        </Grid>
                                      );
                                    })}
                                </Grid>
                              </>
                            )}

                          {values.buttons.buttons.some(
                            (x) => x.type === "PHONE_NUMBER",
                          ) && (
                              <>
                                <Grid item xs={12} mt={2}>
                                  <Stack
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                    spacing={1}
                                    mt={1}
                                  >
                                    <Typography variant="h3" fontWeight={600}>
                                      Call Phone Number
                                    </Typography>
                                  </Stack>
                                  {values.buttons.buttons
                                    .filter((x) => x.type === "PHONE_NUMBER")
                                    .map((button, index) => {
                                      // Get actual index in the full buttons array for error access
                                      const actualIndex =
                                        values.buttons.buttons.findIndex(
                                          (b, i) =>
                                            b.type === "PHONE_NUMBER" &&
                                            values.buttons.buttons
                                              .slice(0, i + 1)
                                              .filter(
                                                (x) => x.type === "PHONE_NUMBER",
                                              ).length ===
                                            index + 1,
                                        );
                                      const buttonErrors = (errors.buttons as any)
                                        ?.buttons?.[actualIndex];
                                      return (
                                        <Grid
                                          key={index}
                                          container
                                          mt={1}
                                          spacing={1}
                                        >
                                          <Grid item xs={3.5}>
                                            <CustomFormLabel>
                                              Country
                                            </CustomFormLabel>
                                            <AutoComplete
                                              fullWidth
                                              value={button.country_code}
                                              options={COUNTRY_LIST.map((x) => ({
                                                label: `(${x.code}) ${x.name}`,
                                                value: x.codeWithoutPrefix,
                                              }))}
                                              placeholder="Select country"
                                              onChange={handleButtonsAutocompleteChange(
                                                "PHONE_NUMBER",
                                                index,
                                                "country_code",
                                              )}
                                              error={
                                                submitAttempted &&
                                                !!buttonErrors?.country_code
                                              }
                                              helperText={
                                                submitAttempted
                                                  ? buttonErrors?.country_code ||
                                                  ""
                                                  : ""
                                              }
                                            />
                                          </Grid>
                                          <Grid item xs={3.5}>
                                            <CustomFormLabel
                                              sx={{ fontWeight: 600 }}
                                            >
                                              Button Text
                                            </CustomFormLabel>
                                            <CustomTextField
                                              fullWidth
                                              value={button.text}
                                              onChange={handleButtonsTextChange(
                                                "PHONE_NUMBER",
                                                index,
                                                "text",
                                              )}
                                              error={
                                                submitAttempted &&
                                                !!buttonErrors?.text
                                              }
                                              helperText={
                                                submitAttempted
                                                  ? buttonErrors?.text || ""
                                                  : ""
                                              }
                                            />
                                          </Grid>
                                          <Grid item xs={3.5}>
                                            <CustomFormLabel
                                              sx={{ fontWeight: 600 }}
                                            >
                                              Phone Number
                                            </CustomFormLabel>

                                            <PhoneTextField
                                              label=""
                                              name="phone_number"
                                              value={button.phone_number}
                                              fullWidth
                                              onChange={(value: string) => {
                                                const newvalues = produce(
                                                  values,
                                                  (draftValues) => {
                                                    const filteredDraftValues =
                                                      draftValues.buttons.buttons.filter(
                                                        (x) =>
                                                          x.type ===
                                                          "PHONE_NUMBER",
                                                      );
                                                    filteredDraftValues[index][
                                                      "phone_number"
                                                    ] = value;
                                                  },
                                                );
                                                setValues(newvalues);
                                              }}
                                              error={
                                                submitAttempted &&
                                                !!buttonErrors?.phone_number
                                              }
                                              helperText={
                                                submitAttempted
                                                  ? buttonErrors?.phone_number ||
                                                  ""
                                                  : ""
                                              }
                                            />
                                          </Grid>
                                          <Grid item xs={1}>
                                            <Stack
                                              direction={"row"}
                                              height={"100%"}
                                              alignItems={"end"}
                                              justifyContent={"center"}
                                              spacing={1}
                                            >
                                              <Button
                                                variant="text"
                                                startIcon={<Close />}
                                                sx={{ mb: 0.5 }}
                                                onClick={handleDeleteClick(
                                                  actualIndex,
                                                )}
                                              ></Button>
                                            </Stack>
                                          </Grid>
                                        </Grid>
                                      );
                                    })}
                                </Grid>
                              </>
                            )}

                          {values.buttons.buttons.some(
                            (x) => x.type === "QUICK_REPLY",
                          ) && (
                              <>
                                <Grid item xs={12} mt={2}>
                                  <Stack
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                    spacing={1}
                                    mt={1}
                                  >
                                    <Typography variant="h3" fontWeight={600}>
                                      Quick Reply
                                    </Typography>
                                    <IconButton
                                      onClick={handleAddClick("QUICK_REPLY")}
                                    >
                                      <Add />
                                    </IconButton>
                                  </Stack>
                                  {values.buttons.buttons
                                    .filter((x) => x.type === "QUICK_REPLY")
                                    .map((button, index) => {
                                      // Get actual index in the full buttons array for error access
                                      const actualIndex =
                                        values.buttons.buttons.findIndex(
                                          (b, i) =>
                                            b.type === "QUICK_REPLY" &&
                                            values.buttons.buttons
                                              .slice(0, i + 1)
                                              .filter(
                                                (x) => x.type === "QUICK_REPLY",
                                              ).length ===
                                            index + 1,
                                        );
                                      const buttonErrors = (errors.buttons as any)
                                        ?.buttons?.[actualIndex];
                                      return (
                                        <Grid
                                          key={index}
                                          container
                                          mt={1}
                                          spacing={1}
                                        >
                                          <Grid item xs={7}>
                                            <CustomFormLabel
                                              sx={{ fontWeight: 600 }}
                                            >
                                              Button Text
                                            </CustomFormLabel>
                                            <CustomTextField
                                              fullWidth
                                              value={button.text}
                                              onChange={handleButtonsTextChange(
                                                "QUICK_REPLY",
                                                index,
                                                "text",
                                              )}
                                              error={
                                                submitAttempted &&
                                                !!buttonErrors?.text
                                              }
                                              helperText={
                                                submitAttempted
                                                  ? buttonErrors?.text || ""
                                                  : ""
                                              }
                                            />
                                          </Grid>
                                          <Grid item xs={1}>
                                            <Stack
                                              direction={"row"}
                                              height={"100%"}
                                              alignItems={"end"}
                                              justifyContent={"center"}
                                              spacing={1}
                                            >
                                              <Button
                                                variant="text"
                                                startIcon={<Close />}
                                                sx={{ mb: 0.5 }}
                                                onClick={handleDeleteClick(
                                                  actualIndex,
                                                )}
                                              ></Button>
                                            </Stack>
                                          </Grid>
                                        </Grid>
                                      );
                                    })}
                                </Grid>
                              </>
                            )}
                        </Grid>
                      )}

                      {isCategoryAuthentication && (
                        <Grid item xs={7}>
                          {autofillBtnText ? (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                mt: 2,
                              }}
                            >
                              <CustomTextField
                                label="package_name"
                                fullWidth
                                value={
                                  values?.buttons?.buttons?.[0]?.value
                                    ?.package_name
                                }
                                onChange={(e) => {
                                  const newValues = produce(
                                    values,
                                    (draftValues) => {
                                      if (
                                        draftValues.buttons.buttons[0] &&
                                        draftValues.buttons.buttons[0].value
                                      ) {
                                        draftValues.buttons.buttons[0].value.package_name =
                                          e.target.value;
                                      }
                                    },
                                  );
                                  setValues(newValues);
                                }}
                                placeholder="Enter Package Name (e.g., com.example.luckyshrub)"
                                InputLabelProps={{ shrink: true }}
                                error={
                                  submitAttempted &&
                                  !!(errors.buttons as any)?.buttons?.[0]
                                    ?.package_name
                                }
                                helperText={
                                  submitAttempted &&
                                    (errors.buttons as any)?.buttons?.[0]
                                      ?.package_name
                                    ? (errors.buttons as any).buttons[0]
                                      .package_name
                                    : ""
                                }
                              />
                              <CustomTextField
                                label="signature_hash"
                                fullWidth
                                value={
                                  values?.buttons?.buttons?.[0]?.value
                                    ?.signature_hash
                                }
                                onChange={(e) => {
                                  const newValues = produce(
                                    values,
                                    (draftValues) => {
                                      if (
                                        draftValues.buttons.buttons[0] &&
                                        draftValues.buttons.buttons[0].value
                                      ) {
                                        draftValues.buttons.buttons[0].value.signature_hash =
                                          e.target.value;
                                      }
                                    },
                                  );
                                  setValues(newValues);
                                }}
                                placeholder="Enter Signature Batch (e.g., K8a%2FAINcGX7)"
                                InputLabelProps={{ shrink: true }}
                                error={
                                  submitAttempted &&
                                  !!(errors.buttons as any)?.buttons?.[0]
                                    ?.signature_hash
                                }
                                helperText={
                                  submitAttempted &&
                                    (errors.buttons as any)?.buttons?.[0]
                                      ?.signature_hash
                                    ? (errors.buttons as any).buttons[0]
                                      .signature_hash
                                    : ""
                                }
                              />
                            </Box>
                          ) : (
                            <>
                              {/* <CustomFormLabel sx={{ fontWeight: 600 }}>
                                Button Text
                              </CustomFormLabel>
                              <CustomTextField
                                fullWidth
                                value={
                                  values?.buttons?.buttons?.[0]?.text ??
                                  values?.buttons?.buttons?.[0]?.value?.text ??
                                  ""
                                }
                                onChange={(e) => {
                                  const textVal = e.target.value;
                                  const newValues = produce(
                                    values,
                                    (draftValues) => {
                                      if (!draftValues.buttons) {
                                        draftValues.buttons = {
                                          type: "BUTTONS",
                                          buttons: [],
                                        };
                                      }
                                      if (!draftValues.buttons.buttons[0]) {
                                        draftValues.buttons.buttons[0] = {
                                          type: "OTP",
                                          text: textVal,
                                          value: {
                                            otp_type: "COPY_CODE",
                                            text: textVal,
                                            autofill_text: "",
                                            package_name: "",
                                            signature_hash: "",
                                          },
                                        };
                                      } else {
                                        draftValues.buttons.buttons[0].text =
                                          textVal;
                                        if (
                                          draftValues.buttons.buttons[0].value
                                        ) {
                                          draftValues.buttons.buttons[0].value.text =
                                            textVal;
                                        }
                                      }
                                    },
                                  );
                                  setValues(newValues);
                                }}
                                placeholder="Enter button text (e.g., Copy Code)"
                                error={
                                  submitAttempted &&
                                  !!(errors.buttons as any)?.buttons?.[0]?.text
                                }
                                helperText={
                                  submitAttempted &&
                                  (errors.buttons as any)?.buttons?.[0]?.text
                                    ? (errors.buttons as any).buttons[0].text
                                    : ""
                                }
                              /> */}
                            </>
                          )}
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={4} mt={2}>
                  <Typography variant="h3" fontWeight={600}>
                    Preview Template
                  </Typography>
                  <Box
                    p={2}
                    pt={4}
                    borderRadius={2}
                    sx={{
                      backgroundColor: "#efeae2",
                      backgroundImage: `url(${WhatsappBgImg})`,
                      backgroundRepeat: "repeat",
                      backgroundSize: "auto",
                      backgroundBlendMode: "multiply",
                      minHeight: "300px",
                    }}
                  >
                    <PreviewTemplate
                      isFromTemplateCreation
                      template={values}
                      loading={whatsAppTemplateDataLoading}
                      headerType={
                        headerType === "MEDIA" ? mediaType : headerType
                      }
                      headerMedia={
                        uploadedFile ||
                        values.header?.example?.header_handle?.[0]?.file
                      }
                      headerVariableValue={
                        values.header?.example?.header_handle?.[0]?.url ||
                        values.header?.example?.header_handle?.[0]?.path ||
                        ""
                      }
                      bodyVariableValues={values.example?.body_text?.reduce(
                        (acc, item, index) => {
                          if (item) {
                            acc[index + 1] = item;
                          }
                          return acc;
                        },
                        {} as { [key: string]: string },
                      )}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Stack
                mt={3}
                direction={"row"}
                position={"fixed"}
                bottom={20}
                left={0}
                right={20}
                justifyContent={"right"}
                spacing={2}
              >
                <Button
                  variant="contained"
                  type="button"
                  onClick={() => setOpenSample(true)}
                  sx={{
                    backgroundColor:
                      submitAttempted && showSampleVariableError
                        ? "error.main"
                        : "",
                  }}
                >
                  Add Sample Variable
                </Button>

                <Button
                  variant="contained"
                  type="button"
                  onClick={handleGlobalSaveClick}
                >
                  Save
                </Button>
              </Stack>
            </form>
          </StandardCard>
        </PageContainer>
      </PageLoader>
      {openSample && (
        <VaraiblesSampleDialog
          open={openSample}
          content={values.body.text}
          varaibles={values.example.body_text}
          mediaType={mediaType}
          headerType={headerType}
          mediaFiles={values.header?.example?.header_handle || []}
          onClose={() => setOpenSample(false)}
          onSave={handleSaveVaraible}
        />
      )}

      {openMapPicker && (
        <MapPicker
          open={openMapPicker}
          onClose={() => setOpenMapPicker(false)}
          onHandleLocationSelect={handleLocationSelect}
        />
      )}

      <Snackbar
        open={!!showError}
        autoHideDuration={5000}
        onClose={() => setShowError(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ zIndex: 9999 }}
      >
        <Alert
          onClose={() => setShowError(null)}
          severity="error"
          sx={{ width: 400 }}
        >
          <List dense sx={{ p: 0 }}>
            {showError &&
              showError.map((msg, index) => (
                <ListItem key={index} sx={{ py: 0 }}>
                  <ListItemText
                    primary={typeof msg === "string" ? msg : String(msg)}
                  />
                </ListItem>
              ))}
          </List>
        </Alert>
      </Snackbar>
    </>
  );
};
